import React from 'react'
import { useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'

import { AppState } from '../../types'
import './style.scss'

const CountryCart = () => {
  const countriesBasket = useSelector(
    (state: AppState) => state.countries.inCart
  )
  return (
    <div className="cart">
      <div className="cart__left">
        <NavLink to="/cart" className="cart__link--full grow">
          <i className="fas fa-cart-arrow-down fa-2x"></i>
        </NavLink>
      </div>
      {countriesBasket.length > 0 && (
        <div className="cart__right animate-appear grow">
          <p>{countriesBasket.length}</p>
        </div>
      )}
    </div>
  )
}

export default CountryCart
